/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingdisconnect1Inputs */

const en_crosspostingdisconnect1 = /** @type {(inputs: Crosspostingdisconnect1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnect`)
};

const de_crosspostingdisconnect1 = /** @type {(inputs: Crosspostingdisconnect1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trennen`)
};

/**
* | output |
* | --- |
* | "Disconnect" |
*
* @param {Crosspostingdisconnect1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingdisconnect1 = /** @type {((inputs?: Crosspostingdisconnect1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingdisconnect1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingdisconnect1(inputs)
	return de_crosspostingdisconnect1(inputs)
});
export { crosspostingdisconnect1 as "crosspostingDisconnect" }